import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { GridViewComponent } from './grid-view.component';
import { IonicModule } from '@ionic/angular';
import { LeadManagmentRoutingModule } from '../../lead-managment/lead-managment-routing.module';
import { InventoryItineraryRoutingModule } from '../../inventory-itinerary/inventory-itinerary-routing.module';
import { SharedModule } from '../shared.module';
import { ApplyFormatterPipe } from '../pipes/apply-formatter.pipe';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    GridViewComponent,
    ApplyFormatterPipe
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    LeadManagmentRoutingModule,
    InventoryItineraryRoutingModule,
  ],
  exports:[
    GridViewComponent,
    ApplyFormatterPipe
  ],
  providers:[
    DatePipe,
    CurrencyPipe
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class GridViewModule { }
